import { TemplateType } from "../constants/templateData";

export interface TemplateObject {
    id:string,
    name:string,
    owner:string,
    organization:string,
    created_timestamp:number,
    modified_timestamp:number
    type?:string,
    tag?:string[],
    super_org?:string[],
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    mapping?:{[key:string]:any},
    edit_locked_to_owner?:boolean,
    integration?: string,
    duplication_details?:{
        from_template_id?:string,
        apply_super_org_permissions?:boolean
    }
}

export type TemplateTypeMap = {
    [TemplateType.MEDICAL]: TemplateObject[];
    [TemplateType.COMMUNICATIONS]: TemplateObject[];
    [TemplateType.RECORDSRECAP]: TemplateObject[];
};

export enum ContentType {
    PARAGRAPH = "paragraph",
    LIST = "list",
    NUMBER = "number",
    SUBSECTION = "subsection",
    HARDCODED = "hardcoded",
}

export interface EntryType{
    entryKey:string
    name:string| undefined
    emptyName?:boolean
    description?:string|undefined
    defaultValue?:string|undefined
    type:ContentType
    hardcodedValue?:string|undefined
    emptyHardcodedValue?:boolean
    subEntries?:EntryType[]
}


export enum SectionTypes {
    NORMAL = "normal",
    LIST = "list",
    PARAGRAPH = "paragraph",
    NUMBER = "number",
    COLLECTION = "collection",
    SIMPLE_LIST = "simple_list",
    HARDCODED = "hardcoded",
    TIMELINE = "timeline",
    DIAGRAM = "diagram",
    SPACES = "spaces",
    GENERAL_INSTRUCTIONS = "general_instructions",
}

export interface SectionType{
    sectionKey:string
    type:SectionTypes
    name:string|undefined
    emptyName?:boolean
    entries:EntryType[]
    description?:string|undefined
    defaultValue?:string|undefined
    hardcodedValue?:string|undefined
    emptyHardcodedValue?:boolean
    diagram?:string|undefined
}